import { Injectable } from '@angular/core'
import { SessionNote } from '@ftr/annotations-contracts/v2'
import { Uuid } from '@ftr/contracts/type/shared'
import { ApiResult, RemoteData } from '@ftr/foundation'
import { AnnotationsService } from '../base'

@Injectable({
  providedIn: 'root',
})
export class SessionNotesService extends AnnotationsService {
  /**
   * @param courtSystemId
   * @param recordingId
   * @param courtroomSessionId
   * @returns Session note for a given session.
   */
  getSessionNotes(courtSystemId: Uuid, recordingId: Uuid, courtroomSessionId: Uuid): ApiResult<SessionNote | null> {
    return this.performApiRequestV2({
      courtSystemId,
      requestFn: client =>
        client.sessionNotes.getSessionNote({ params: { courtSystemId, recordingId, courtroomSessionId } }),
      responseMapFn: result => {
        if (result.status !== 200) {
          return RemoteData.failure(new Error(result.body?.error))
        }

        return RemoteData.success(result.body)
      },
    })
  }

  /**
   * Creates or updates the session note for a courtroom session (upsert).
   */
  updateSessionNote(
    courtSystemId: Uuid,
    recordingId: Uuid,
    courtroomSessionId: Uuid,
    noteText: string,
  ): ApiResult<SessionNote> {
    return this.performApiRequestV2({
      courtSystemId,
      requestFn: client =>
        client.sessionNotes.putSessionNote({
          params: { courtSystemId, recordingId, courtroomSessionId },
          body: { noteText },
        }),
      responseMapFn: result => {
        if (result.status !== 200) {
          return RemoteData.failure(new Error(result.body?.error))
        }

        return RemoteData.success(result.body)
      },
    })
  }
}
